// extracted by mini-css-extract-plugin
export default {"basel-view":"style_basel-view__0auib","bg-map":"style_bg-map__z2wHY","bg-river":"style_bg-river__t39sa","link-points":"style_link-points__mody-","is-idle":"style_is-idle__OmZxi"};